export default "__VITE_ASSET__Dqe3Q7j7__"